var _circle, _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E5FFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0837 10.7514C10.2211 10.3607 10.6492 10.1553 11.04 10.2927L11.3414 10.3986C11.9579 10.6154 12.4815 10.7994 12.8936 11.0016C13.3343 11.2178 13.7121 11.4842 13.9963 11.9C14.2783 12.3127 14.3947 12.7654 14.4484 13.2618C14.4725 13.484 14.4852 13.7299 14.4918 14.0002H25.1301C26.815 14.0002 28.3318 14.0002 28.7757 14.5773C29.2197 15.1544 29.0461 16.0239 28.699 17.763L28.1992 20.1877C27.8841 21.7166 27.7266 22.481 27.1748 22.9306C26.6231 23.3802 25.8426 23.3802 24.2816 23.3802H18.9787C16.1898 23.3802 14.7953 23.3802 13.9289 22.4664C13.0625 21.5526 12.9993 20.5818 12.9993 17.6402L12.9993 15.0386C12.9993 14.2986 12.9983 13.8034 12.9571 13.4232C12.9178 13.0598 12.8481 12.8784 12.7578 12.7463C12.6698 12.6175 12.5361 12.497 12.2329 12.3483C11.91 12.1899 11.4713 12.0343 10.8037 11.7996L10.5425 11.7077C10.1517 11.5704 9.94629 11.1422 10.0837 10.7514Z",
    fill: "#84DCC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 26C16.3284 26 17 26.6716 17 27.5C17 28.3284 16.3284 29 15.5 29C14.6716 29 14 28.3284 14 27.5C14 26.6716 14.6716 26 15.5 26Z",
    fill: "#1177BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 26.0001C25.3284 26.0001 26 26.6716 26 27.5001C26 28.3285 25.3284 29.0001 24.5 29.0001C23.6716 29.0001 23 28.3285 23 27.5001C23 26.6716 23.6716 26.0001 24.5 26.0001Z",
    fill: "#1177BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5431 17.5172C23.8288 17.2173 23.8172 16.7426 23.5172 16.4569C23.2173 16.1712 22.7426 16.1828 22.4569 16.4828L20.1429 18.9125L19.5431 18.2828C19.2574 17.9828 18.7827 17.9712 18.4828 18.2569C18.1828 18.5426 18.1712 19.0173 18.4569 19.3172L19.5998 20.5172C19.7413 20.6659 19.9376 20.75 20.1429 20.75C20.3481 20.75 20.5444 20.6659 20.686 20.5172L23.5431 17.5172Z",
    fill: "#1177BD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#209E49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarted);
export default __webpack_public_path__ + "static/media/carted.8af4cdcf610b8b4afa2dfaa4f4725026.svg";
export { ForwardRef as ReactComponent };